<div class="modal fade" [id]="modalId" tabindex="-1" aria-labelledby="printModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="printModalLabel">{{title}}</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <ng-content></ng-content>
      </div>
      <div class="modal-footer p-1">
        <button type="button" class="btn btn-secondary m-2" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
